define([
  'underscore',
], (_) => {
  let fixedElements = [];
  const html = document.getElementsByTagName('html')[0];

  const sumoClasses = [
    'sumome-react-modal-container',
    'sumome-dialog-popup',
    'sumome-dialog-popup-overlay',
    'sumome-image-sharer',
    'sumome-contactform-left-page-hidden',
    'sumome-contactform-right-page-hidden',
    'sumome-react-wysiwyg-component',
    'sumome-smartbar-powered-by-variant',
  ];

  const parseSumoData = (element) => {
    if (!element.dataset.sumoWelcomeMatData) return {};

    let data;
    try {
      data = JSON.parse(element.dataset.sumoWelcomeMatData);
    } catch(e) {
      console.log('JSON parse error:', e);
      data = {};
    }
    return data;
  };

  const applyOriginalStyles = (element) => {
    if (element.dataset.sumoWelcomeMatData) {
      const data = parseSumoData(element);
      const originalStyle = data.originalStyles;
      _.extend(element.style, _.omit(originalStyle, 'transitionDuration'));

      setTimeout(() => {
        // Styles that need to be applied after other styles
        _.extend(element.style, _.pick(originalStyle, 'transitionDuration'));
      }, 0);
    }
  };

  const storeOriginalStyles = (element) => {
    const style = window.getComputedStyle(element);
    const data = {};

    // TODO: Add prefixed styles
    data.originalStyles = {
      transform: element.style.transform,
      transitionDuration: element.style.transitionDuration,
      animationFillMode: element.style.animationFillMode,
      animationDuration: element.style.animationDuration,
    };

    if (element.tagName === 'IFRAME') {
      data.originalStyles.display = element.style.display;
    }

    /* This may be needed eventually */
    /*
    data.originalTransform = style.getPropertyValue('transform');
    data.originalTransformPriority = style.getPropertyPriority('transform');
    data.originalTransitionDuration = style.getPropertyValue('transition-duration');
    data.originalTransitionDurationPriority = style.getPropertyPriority('transition-duration');
    data.originalAnimationFillMode = style.getPropertyValue('animation-fill-mode');
    data.originalAnimationFillModePriority = style.getPropertyPriority('animation-fill-mode');
    data.originalAnimationDuration = style.getPropertyValue('animation-duration');
    data.originalAnimationDurationPriority = style.getPropertyPriority('animation-duration');
    */

    element.dataset.sumoWelcomeMatData = JSON.stringify(data);
  };

  /**
  * Animates body and welcome mat down. Animates scrollTop up. Hides fixed elements.
  */
  const styleBufferTop = (matEl) => {
    const elements = document.body.querySelectorAll('*');

    if (fixedElements.length) {
      // Apply original styles first
      _.each(fixedElements, (element) => applyOriginalStyles(element));
    }

    // Find fixed elements
    fixedElements = _.filter(elements, (element) => {
      const className = element.getAttribute('class') || '';
      const style = window.getComputedStyle(element);
      const position = style.getPropertyValue('position');

      // Filter out sumo elements
      if (element === matEl || element.getAttribute('id') === 'sumome-modal-mask' || _.intersection(sumoClasses, className.split(' ')).length) {
        return false;
      }

      if (position === 'fixed') {
        return true;
      }

      if (position !== 'absolute') {
        return false;
      }

      // Check parent elements
      const relativeParents = [];
      let p = element.parentNode;
      while (p && p !== document.documentElement && p !== document.body) {
        const parentStyle = window.getComputedStyle(p);
        const parentPosition = parentStyle.getPropertyValue('position');
        const top = element.offsetTop;

        if (['relative', 'absolute'].indexOf(parentPosition) > -1) {
          relativeParents.unshift(p);
        }

        p = p.parentNode;
      }

      if (!relativeParents.length) {
        return true;
      }

      if (top <= window.innerHeight && top > -2000) {
        return true;
      }

      return false;
    });

    _.each(fixedElements, (element) => {
      // Store original styles, then clear them out
      storeOriginalStyles(element);

      // Remove styles that interfere with welcome mat
      element.style.transitionDuration = '0s';
      element.style.transform = 'scale(0, 0)';
      element.style.animationFillMode = 'none';
      element.style.animationDuration = '0s';

      if (element.tagName === 'IFRAME') {
        element.style.display = 'none';
      }
    });

    if (html) {
      html.dataset.sumoWelcomeMatData = JSON.stringify({
        originalStyles: { position: getComputedStyle(html).position }
      });

      html.style.position = 'static';
    }
  };

  /**
  * Sets values back to original when removing Welcome Mat.
  */
  const removeStyleBuffer = () => {
    _.each(fixedElements, (element) => applyOriginalStyles(element));

    if (html) {
      applyOriginalStyles(html);
    }
  };

  return {
    styleBufferTop,
    removeStyleBuffer,
  };
});
